import { Highlight } from 'react-vis';

export class SelectionArea<X = number, Y = number> extends Highlight<X, Y> {
  // Override stopBrushing() to return null to the callback if the mouse leaves the area.
  // https://github.com/uber/react-vis/blob/master/packages/react-vis/src/plot/highlight.js
  stopBrushing(e: MouseEvent) {
    if (e.type === 'mouseleave') {
      let { brushArea } = this.state as any;
      // Cause selection area to be null by brush area being too small
      brushArea.top = brushArea.bottom;
    }
    super.stopBrushing(e);
  }
}
